module.exports = __webpack_public_path__ + "img/xfarmer-wechat-img.png";